// extracted by mini-css-extract-plugin
module.exports = {"carousel":"product-carousel_carousel__7193n","carousel__card":"product-carousel_carousel__card__YgT7O"};